export type MultiSelectBlockRectLookup = (blockId: string) => DOMRect | null;

export function resolveMultiSelectRailHostBlockIdFromRects(
  selectedBlockIds: readonly string[],
  rectForBlockId: MultiSelectBlockRectLookup,
): string | null {
  if (selectedBlockIds.length === 0) {
    return null;
  }

  if (selectedBlockIds.length === 1) {
    return selectedBlockIds[0];
  }

  let hostId: string | null = null;
  let bestTop = Infinity;
  let bestLeft = Infinity;

  for (const blockId of selectedBlockIds) {
    const rect = rectForBlockId(blockId);
    if (rect === null) {
      continue;
    }

    if (rect.top < bestTop || (rect.top === bestTop && rect.left < bestLeft)) {
      bestTop = rect.top;
      bestLeft = rect.left;
      hostId = blockId;
    }
  }

  return hostId;
}

function blockFrameRect(canvasRoot: HTMLElement, blockId: string): DOMRect | null {
  const node = canvasRoot.querySelector<HTMLElement>(
    `[data-entity-id="block:${CSS.escape(blockId)}"]`,
  );
  return node?.getBoundingClientRect() ?? null;
}

export function resolveMultiSelectRailHostBlockId(
  selectedBlockIds: readonly string[],
  canvasRoot: HTMLElement,
): string | null {
  return resolveMultiSelectRailHostBlockIdFromRects(selectedBlockIds, blockId =>
    blockFrameRect(canvasRoot, blockId),
  );
}

function rowFrameRect(canvasRoot: HTMLElement, rowId: string): DOMRect | null {
  const node = canvasRoot.querySelector<HTMLElement>(
    `[data-entity-id="row:${CSS.escape(rowId)}"]`,
  );
  return node?.getBoundingClientRect() ?? null;
}

export function resolveMultiSelectRailHostRowId(
  selectedRowIds: readonly string[],
  canvasRoot: HTMLElement,
): string | null {
  return resolveMultiSelectRailHostBlockIdFromRects(selectedRowIds, rowId =>
    rowFrameRect(canvasRoot, rowId),
  );
}
